export { default as FormDialog } from './FormDialog';
export { default as InfoDialog } from './InfoDialog';
export type { FormDialogProps, InfoDialogProps, DialogHandleValue } from './Dialog.types';
